import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { UserTrackerService } from '../services/tracking/user-tracker.service';

@Injectable()
export class TrackingInterceptor implements HttpInterceptor {
  constructor(private userTrackerService: UserTrackerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse && request.headers.has('is-tracked')) {
          event = event.clone();

          const trackJSON = this.userTrackerService.buildUserTrackerJSON(request, event);

          this.userTrackerService.track(trackJSON).pipe(first()).subscribe();

          return event;
        } else {
          return event;
        }
      })
    );
  }
}
